// 二级品牌馆配置 登场了
export default {
  'hnxbzzk.ubanquan.cn': {
    // 主应用二级品牌馆id映射
    development: {
      storeNo: 'ST788800000100001677031541',
      storeName: '湖南省细胞组织库',
      microHost: 'hnxbzzk-brand.ubanquan.cn'
    },
    test: {
      storeNo: 'ST788800000100001677031541',
      storeName: '湖南省细胞组织库',
      microHost: 'hnxbzzk-brand.ubanquan.cn'
    },
    realpre: {
      storeNo: 'ST788800000100001677031541',
      storeName: '湖南省细胞组织库',
      microHost: 'hnxbzzk-brand.ubanquan.cn'
    },
    production: {
      storeNo: 'ST788800000100001677031541',
      storeName: '湖南省细胞组织库',
      microHost: 'hnxbzzk-brand.ubanquan.cn'
    }
  }
};